<template>
  <div>
    <div class="newsli-container" v-loading="loading">
    	<ul class="clearfix">
    		<li class="clearfix" v-for="news in newsList" :key="`news${news.id}`">
    			<a href="javascript:;" @click="tonewsDetail(news)">
    				<div v-show="news.status == 1" class="newli-container-state">

    				</div>
    				<div class="newli-container-content">
    					<div class="newli-container-title">{{news.title}}</div>
    					<div class="newli-container-time">{{news.sendTime}}</div>
    				</div>
    			</a>
    		</li>
<!--    		<li>
    			<a href="javascript:;">
    				<div class="newli-container-title">大国粮仓二十载 砥砺奋进新时代 ——中储粮集团公司举行庆祝成立20周年大会</div>
    				<div class="newli-container-time">2020.11.20 13:23</div>
    			</a>
    		</li> -->
    	</ul>

      <div class="task-pagination" style="text-align: center;" v-show="listlength">
        <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import {ApiGetMyMessage} from '../../../net/accound/index.js'
import {setCookie} from '../../../untils/common.js'
  export default {
    data: function () {
      return {
        pageNum: 1,
        pageSize: 5,
        total: 0,
        loading: false,
        newsList: []
      }
    },
    computed: {
      listlength: function () {
        return this.newsList.length
      },
    },
    methods: {
      getMyCollect: function () {
        const prames = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          platform: 'pc'
        }
        this.loading = true
        ApiGetMyMessage(prames).then(res=>{
          // console.log('res', res)
          this.newsList = res.pc.details
          this.total = res.pc.total
          this.loading = false
        })
      },
      handleCurrentChange: function (index) {
        this.pageNum = index
        this.getMyCollect()
      },
      tonewsDetail: function (item){
        this.$router.push('/News/'+ item.id)
      }
    },
    mounted: function () {
      this.getMyCollect()
    }
  }
</script>

<style scoped>
.newsli-container{
  width: 850px;
  background:#fff;
  height: 600px;
  border-radius: 6px;
  position: relative;
}
.newsli-container ul{
  margin:0;
  padding:0;
}
.newsli-container ul li{
  list-style-type: none;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e5e5;
  float: left;
  width: 810px;
}
.newsli-container ul li a{
  text-decoration: none;
}
.newli-container-title{
  font-size: 16px;
  color: #454545;
  width: 800px;
  overflow: hidden;/*内容超出后隐藏*/
  text-overflow: ellipsis;/* 超出内容显示为省略号*/
  white-space: nowrap;/*文本不进行换行*/
}
.newli-container-time{
  font-size: 14px;
  color: #7f7f7f;
  margin-top: 5px;
}
.newli-container-tips{
  width: 6px;
  height: 6px;
  border-radius: 50%;
  color: #ee1919;
  float: left;
  background-color: #ee1919;
  margin-top: 8px;
  margin-right: 10px;
}
.newli-container-state{
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ee1919;
  float: left;
  margin-top: 8px;
  margin-right: 4px;
}
.newli-container-content{
  width: 800px;
  float: left;
}
.newsli-container ul li a:hover .newli-container-title{
  color: #252525;
}
.newsli-container ul li:hover{
  background:#fafafa;
}
.task-pagination{
  text-align: center;
  position: absolute;
  bottom: 20px;
  width: 100%;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AccMyTool/children/news.vue